// extracted by mini-css-extract-plugin
export default {"root":"StateCard_root__dKvu3","title":"StateCard_title__Bed1n","description":"StateCard_description__PuViG","actions":"StateCard_actions__2Z7Ii","icon":"StateCard_icon__tVBEe"};